import type { ComponentProps, ReactNode } from "react";
import { cn } from "@/utils";

type DataTableFooterProps = ComponentProps<"div"> & {
  summary?: ReactNode;
};

export function DataTableFooter({ children, className, summary, ...props }: DataTableFooterProps) {
  return (
    <div
      className={cn("flex w-full shrink-0 flex-wrap items-center justify-between gap-x-4 text-xs text-muted-foreground", className)}
      data-slot="data-table-footer"
      {...props}
    >
      {summary != null ? (
        <div className="min-w-0 text-xs tabular-nums" data-slot="data-table-summary" role="status">
          {summary}
        </div>
      ) : null}
      {children != null ? <div className="ms-auto min-w-0 max-w-full">{children}</div> : null}
    </div>
  );
}
